import { LocalDate, LocalDateTime } from "@js-joda/core";

/**
 * Call this function to compare local date and time values.
 *
 * @param {LocalDate | LocalDateTime | null | undefined} a
 * @param {LocalDate | LocalDateTime | null | undefined} b
 *
 * @return {number} 0 if equal, -1 if first less than second and 1 if first greater than second
 */
export const localDateTimeCompare = (a?: LocalDate | LocalDateTime | null, b?: LocalDate | LocalDateTime | null): number =>
   toLocalDateTime(a).compareTo(toLocalDateTime(b));

const toLocalDateTime = (date?: LocalDate | LocalDateTime | null): LocalDateTime => {
   if (date instanceof LocalDateTime) {
      return date;
   }
   else if (!date) {
      return LocalDateTime.MIN;
   }

   return date.atStartOfDay();
};
